module.exports = __webpack_public_path__ + "static/media/ic-service.093634f4.svg";